<div fxLayout="colomn wrap">
    <div fxLayout="row wrap">
        <div>
            <h3 class="text-muted">Order Details :</h3>
            <br />
            <div class="mat-table orders-table">
                <div class="mat-header-row">
                    <div class="mat-header-cell">Order Date</div>
                    <div class="mat-header-cell">PO Number</div>
                    <div class="mat-header-cell">Total Price</div>
                </div>
                <div class="mat-row">
                    <div class="mat-cell">{{order.orderDate}}</div>
                    <div class="mat-cell">{{order.ponumber}}</div>
                    <div class="mat-cell">{{order.orderTotal}}</div>
                </div>
            </div>
        </div>
    </div>
    <div fxLayout="row wrap">
        <div>
            <br />
            <h3 class="text-muted">Order Items Details :</h3>
            <br />
            <div class="mat-table orders-table">
                <div class="mat-header-row">
                    <div class="mat-header-cell">Product Name</div>
                    <div class="mat-header-cell">Product Price</div>
                    <div class="mat-header-cell">Quantity</div>
                    <div class="mat-header-cell">Total</div>
                </div>
                <div *ngFor="let orderItem of order.orderItems" class="mat-row">

                    <div class="mat-cell">{{orderItem.productName}}</div>
                    <div class="mat-cell">Rs.{{orderItem.productPrice | number : '1.2-2'}}</div>
                    <div class="mat-cell text-muted"> {{orderItem.cartCount}}</div>
                    <div class="mat-cell">Rs.{{(orderItem.productPrice*orderItem.cartCount) | number : '1.2-2'}}</div>
                </div>
            </div>
        </div>
    </div>
    <div fxLayout="row wrap" fxFlex="100" class="tp">

        <div fxFlex.gt-sm="30">&nbsp;</div>
        <div fxFlex.gt-sm="35">&nbsp;</div>
        <div fxLayout="column" fxLayoutAlign="center start" class="grand-total" fxFlex.gt-sm="35">
            <span><b style="padding-right: 43px;">SubTotal :</b> Rs.{{order.productTotal}}</span>
            <span><b style="padding-right: 75px;">GST :</b> 12%</span>
            <span><b style="padding-right: 32px;">Total Price :</b> Rs.{{order.orderTotal}}</span>
        </div>
    </div>
    <div fxLayout="row wrap">
        <div fxLayout="row wrap" fxFlex="100" fxFlex.gt-sm="50">
            <div fxLayout="column wrap" fxFlex="100" class="p-1">
                <h3 class="text-muted mt-2">Billing Information</h3>
                <div class="divider"></div>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>Address: </b> {{order.invoiceToAddress}}</p>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>City: </b> {{order.invoiceToCity}}</p>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>State: </b> {{order.invoiceToState}}</p>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>Phone: </b> {{order.invoiceToPhone}}</p>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>Pin: </b> {{order.invoiceToPin}}</p>
            </div>
        </div>

        <div fxLayout="row wrap" fxFlex="100" fxFlex.gt-sm="50">
            <div fxLayout="column wrap" fxFlex="100" class="p-1">
                <h3 class="text-muted mt-2">Shipping information</h3>
                <div class="divider"></div>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>Address: </b> {{order.shipToAddress}}</p>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>City: </b> {{order.shipToCity}}</p>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>State: </b> {{order.shipToState}}</p>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>Phone: </b> {{order.shipToPhone}}</p>
            </div>
            <div fxLayout="column" fxFlex="100" class="p-1">
                <p class="text-muted"><b>Pin: </b> {{order.shipToPin}}</p>
            </div>
        </div>
    </div>
</div>